import React from "react";
import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import styled from "@emotion/styled";
import {css} from "@emotion/core";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagramSquare } from '@fortawesome/free-brands-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'

const FirstSectionContainer = styled(Container)`
  min-height: 1034px;
  padding-bottom:120px;
  @media(max-width:767px){
    padding-bottom:20px;
  }
`

const FirstSectionDescription = styled.div`
  color : ${props => props.theme.colors.white};
  font: 20px/28px Roboto;
  text-align:center;
  margin-bottom:25px;
`

const FirstSectionTitle = styled.div`
  color : ${props => props.theme.colors.accent_yellow};
  margin-top:61px;
  font: 58px/62px Abril Fatface;
  text-align:center;
  margin-bottom:25px;
  @media(max-width:767px){
    font: 2.5rem/3rem Abril Fatface;
    margin-top:20px;
    margin-bottom:15px;
  }
`

const ButtonFill1 = styled(Button)`
  height: 60px;
  margin-bottom:100px;
  color: ${props => props.theme.colors.secondary_green_dark} !important;
  background-color: ${props => props.theme.colors.accent_yellow} !important;
  border-color: ${props => props.theme.buttons.primary_button_yellow_green.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props => props.theme.buttons.primary_button_yellow_green.hovered.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_yellow_green.hovered.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_yellow_green.hovered.border_color}  !important;
    box-shadow: 0px 3px 20px ${props => props.theme.colors.gray_shadow} !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:103px;
    }
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.primary_button_yellow_green.pressed.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_yellow_green.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_yellow_green.pressed.border_color}  !important;
    box-shadow: none !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:103px;
    }
  }
  @media(min-width:1199px){
    width:272px;
  }
  @media(min-width:768px){
    margin-right:25px;
  }
  @media(max-width:767px){
    width:100%;
    margin-bottom:20px;
  }
`

const ButtonFill2 = styled(Button)`
  height: 60px;
  margin-bottom:100px;
  color: ${props => props.theme.buttons.secondary_small_button_white_green.normal.color} !important;
  background-color: ${props => props.theme.buttons.secondary_small_button_white_green.normal.background_color} !important;
  border-color: ${props => props.theme.buttons.secondary_small_button_white_green.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props => props.theme.buttons.secondary_small_button_white_green.hovered.color} !important;
    background-color: ${props => props.theme.buttons.secondary_small_button_white_green.hovered.background_color} !important;
    border-color: ${props => props.theme.buttons.secondary_small_button_white_green.hovered.border_color}   !important;
    box-shadow: 0px 3px 20px ${props => props.theme.colors.gray_shadow} !important;
    @media(min-width:1199px){
      margin-top:-3px;
    }
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.secondary_small_button_white_green.pressed.color} !important;
    background-color: ${props => props.theme.buttons.secondary_small_button_white_green.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.secondary_small_button_white_green.pressed.border_color}   !important;
    box-shadow: none !important;
    @media(min-width:1199px){
      margin-top:-3px;
    }
  }
  @media(min-width:1199px){
    width:324px;
  }
  @media(max-width:767px){
    width:100%;
    margin-bottom:20px;
    text-align:ce
  }
`

const CardsContainer = styled.div`
  color: ${props => props.theme.colors.gray_dark};
  justify-content: center;
  display:flex;
  flex-direction:column;
  margin-left:0px;
`

const ProfileCardColumn = styled(Col)`
  display:flex;
  justify-content:center;
`

const ProfileCard = styled(Card)`
  width:278px;
  height:373px;
  text-align:center;
  margin-bottom:30px;
  @media(max-width:768px){
    margin-right:0px;
  }
`
const CardTitle = styled(Card.Title)`
  font: Bold 16px/22px Roboto;
  margin-bottom:4px;
`

const CardText= styled(Card.Text)`
  height:66px;
  margin-top:0;
  margin-bottom:4px;
  font: 15px/22px Roboto;
`

const SocialMediaIcon = styled(FontAwesomeIcon)`
  font-size:2rem;
  color: ${props => props.theme.colors.primary_violet};
  margin-top:3px;
  &:hover {
    color: ${props => props.theme.colors.primary_violet_hover} !important;
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.colors.primary_violet_hover} !important;
  }
`

const WWTeam = [
  {name:"Windy Natriavi", title:"Co-Founder & Chief LadyBoss @WomenWorks / CPO AwanTunai", picture:"windy-natriavi.png", linkedinLink:"https://www.linkedin.com/in/windynatriavi/", instagramLink:"https://www.instagram.com/windynatriavi"},
  {name:"Fransiska P.W. Hadiwidjana", title:"Co-Founder & CTO WomenWorks / Standford MBA Candidate, Class of 2023", picture:"fransiska-pw-hadiwidjana.png", linkedinLink:"https://www.linkedin.com/in/fransiskapw/", instagramLink:"https://www.instagram.com/fransiskapw"},
  {name:"Nadhira Audrelya", title:"Chief of Staff @WomenWorks / Exe. Board, YLI Foundation", picture:"nadhira-audrelya.png", linkedinLink:"https://www.linkedin.com/in/audrelyan/", instagramLink:"https://www.instagram.com/audrelyan"},
  {name:"Athira Fajrina", title:"Engineering Manager @WomenWorks (on sabbatical)", picture:"athira.jpg", linkedinLink:"https://www.linkedin.com/in/athira-fajrina/", instagramLink:""},
  {name:"Krinta Rani Sinuhaji", title:"Business Partnership Manager @WomenWorks", picture:"krinta-rani.jpeg", linkedinLink:"https://www.linkedin.com/in/krinta-rani-sinuhaji-866995114", instagramLink:"https://www.instagram.com/kintisin/"},
  {name:"Mutia Marwa", title:"Software Engineer @WomenWorks", picture:"mutia-marwa.jpeg", linkedinLink:"https://www.linkedin.com/in/mutiamarwa/", instagramLink:"https://www.instagram.com/mutiamarwa/"},
  {name:"Amertya Ardya", title:"Go-To-Market Strategy Lead @WomenWorks/Sr. Brand Manager, BukaLapak", picture:"amertya-ardya.jpeg", linkedinLink:"https://www.linkedin.com/in/amertya-ardya/", instagramLink:""},
  {name:"Dyah P. Kirana", title:"Mentor Team co-Lead @WomenWorks / Sr. Direct Procurement, Ecolab", picture:"dyah-kirana.jpeg", linkedinLink:"https://www.linkedin.com/in/dyah-paramawidya-kirana-b28214107/", instagramLink:""},
  {name:"Fransiska Andita", title:"Mentee Team co-Lead and Ops @WomenWorks", picture:"fransiska-andita.png", linkedinLink:"https://www.linkedin.com/in/fransiska-andita-a54303122/", instagramLink:"https://www.instagram.com/loitecia"},
  {name:"Maulida Azkiya", title:"Data Lead @WomenWorks / Data Scientist, Bukalapak", picture:"maulida-aykiza.jpg", linkedinLink:"https://www.linkedin.com/in/maulida-azkiya-5b3327106/", instagramLink:""},
  {name:"Okky Avianti", title:"Mentee Team co-Lead & Relations @WomenWorks", picture:"okky-avianti.jpeg", linkedinLink:"https://www.linkedin.com/in/okky-avianti/", instagramLink:""}, 
  {name:"Shalika Hanum", title:"Chief Design Officer @WomenWorks/UX Design Lead for FinTech, Star", picture:"shalika-hanum.png", linkedinLink:"https://www.linkedin.com/in/shalika-hanum-08709559/", instagramLink:"https://shalika.format.com/"},
  {name:"Shelia Lauvita", title:"Growth Manager @WomenWorks / CMO at Sari Kayu", picture:"shelia-lauvita.jpeg", linkedinLink:"https://www.linkedin.com/in/shalika-hanum-08709559/", instagramLink:"https://shalika.format.com/"},
  {name:"Stefanny Widjaja", title:"Partnership Lead @WomenWorks", picture:"stefanny-widjaja.jpeg", linkedinLink:"https://www.linkedin.com/in/stefanny97/", instagramLink:""},
  {name:"Vonny Andria", title:"Community Co-lead @WomenWorks", picture:"vonny-andria.jpeg", linkedinLink:"https://www.linkedin.com/in/vonny-andria-3920aa134/", instagramLink:"https://www.instagram.com/vonnyandriaa/"},
  {name:"Wimala Puspa", title:"Product Director @WomenWorks / Head of Product, AlloFresh", picture:"wimala-puspa.jpeg", linkedinLink:"https://id.linkedin.com/in/wimalapuspa/", instagramLink:"https://www.instagram.com/wimalapuspa/"},
  {name:"Winni Nurul Permana", title:"Content Marketing Manager @WomenWorks/Content Specialist, Disparbud Bandung", picture:"winni-nurul.jpeg", linkedinLink:"https://www.linkedin.com/in/wini-nurul-permana-520162197/", instagramLink:""},
  {name:"Annisa Devina", title:"Social Media Officer @WomenWorks", picture:"annisa-devina.jpeg", linkedinLink:"https://www.linkedin.com/in/annisadevina/", instagramLink:""},
  {name:"Ayu Isnaini", title:"Software QA @WomenWorks /AQA 2 Payments, Kargo Technologies", picture:"ayu-isnaini.jpeg", linkedinLink:"https://www.linkedin.com/in/ayu-isnaini/", instagramLink:""},
  {name:"Bella Zahra", title:"Mentee Strac & Ops @WomenWorks /Assurance Associate, PwC Indonesia", picture:"bella-zahra.jpeg", linkedinLink:"https://www.linkedin.com/in/bella-zahra-rnoch/", instagramLink:""},
  {name:"Caesaria Ayu", title:"Mentor Engagement & Ops @WW / Financial Control - Corp. Planning, PT ANTAM Tbk.", picture:"caesaria-ayu.jpeg", linkedinLink:"https://www.linkedin.com/in/caesaria-ayu/", instagramLink:""},
  {name:"Carrene Wijaya", title:"Mentor Relations @WomenWorks", picture:"carrene-wijaya.jpeg", linkedinLink:"https://www.linkedin.com/in/chatarina-carrene-wijaya/", instagramLink:""},
  {name:"Devina Mahendriyani", title:"Partnership Consultant @WomenWorks", picture:"devina-mahendriyani.jpeg", linkedinLink:"https://www.linkedin.com/in/devinamahendriyani/", instagramLink:"https://www.instagram.com/devinamahendriyani/"},
  {name:"Galih Pratama", title:"Designer @WomenWorks / Graphic Designer, Ditjen Kekayaan Intelektual", picture:"galih.jpg", linkedinLink:"", instagramLink:"https://www.instagram.com/guudart/"},
  {name:"Lydia Natasha Hadiwinata", title:"Content Strategist @WomenWorks / Content Manager, Hyundai Motorstudio", picture:"lydia-natasha.jpeg", linkedinLink:"https://www.linkedin.com/in/natashahadiwinata/", instagramLink:""},
  {name:"Mutiara Hana", title:"QA Engineer @WomenWorks / Tech Recruiter at Gojek", picture:"mutiara-hana.jpeg", linkedinLink:"https://www.linkedin.com/in/mutiarahana/", instagramLink:""},
  {name:"Nabila Azzahra", title:"Content Creator @WomenWork", picture:"nabila-azzahra.jpeg", linkedinLink:"", instagramLink:"https://www.linkedin.com/in/nabilarazzahra"},
  {name:"Natasha Efendy", title:"Software Engineer @ WomenWorks / Software Engineer, Gojek", picture:"natasha-efendy.png", linkedinLink:"https://www.linkedin.com/in/natasha-efendy-949543198", instagramLink:""},
  {name:"Nisrina Dinda Dhamayanti", title:"Data Team @WomenWork", picture:"nisrina-dinda.jpeg", linkedinLink:"https://www.linkedin.com/in/nisrinadinda/", instagramLink:""},
  {name:"Regina Martha Pittauli", title:"Go-to-Market Officer @WomenWorks", picture:"regina-martha.jpeg", linkedinLink:"https://www.linkedin.com/in/reginamartha/", instagramLink:""},
  {name:"Rizky Pradhani Ananda", title:"Product Manager @WomenWorks / Product Manager, KitaBeli", picture:"rizky-pradani.jpeg", linkedinLink:"https://www.linkedin.com/in/rizky-pradhani-ananda-057666107/", instagramLink:""},
  {name:"Seli Ballo", title:"Product Manager @WomenWorks / LSE MSc Candidate, class of 2023", picture:"seli-ballo.jpeg", linkedinLink:"https://www.linkedin.com/in/seliballo95/", instagramLink:""},
  {name:"Shafira Hidayat", title:"Mentor Engagement & Ops @WW / VP GirlUp IDN / Policy Analyst, Kementrian PUPR", picture:"shafira-hidayat.jpeg", linkedinLink:"https://www.linkedin.com/in/shafira-hidayat/", instagramLink:""},
  {name:"Umu Ainia", title:"Community Team @ WW / School Partnership Officer, Keluarga Kita", picture:"umu-ainia.jpeg", linkedinLink:"https://www.linkedin.com/in/umu-ainia-725b93123/", instagramLink:""},
  {name:"Vriske Rusniko", title:"UI/UX Designer @WomenWorks ", picture:"vriske-rusniko.jpeg", linkedinLink:"https://www.linkedin.com/in/vriske/", instagramLink:"https://www.instagram.com/vriskerusniko/"},
  {name:"Winny Soerianto", title:"Community Lead (Internal) @WW / Lab Technician, Medical Science & Computing", picture:"winny-soerinto.jpeg", linkedinLink:"https://www.linkedin.com/in/winnysoerianto/", instagramLink:""},
  ];

export default function Home() {
  return (      
    <div css={css`background: url(/women.svg) no-repeat; background-position: center bottom;`}>
    <FirstSectionContainer>
      <Row className="justify-content-center">
        <Col md="12" lg="8">
          <FirstSectionTitle>
            We are bad-ass. Connected. Financially independent.
          </FirstSectionTitle>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="12" lg="8">
          <FirstSectionDescription>
            Founded in 2019, WomenWorks is the place for women to connect, empower, and reach their fullest potential. Our mission is to build meaningful connections for women to achieve their career-oriented and personal development goals.
          </FirstSectionDescription>
        </Col>
      </Row>
      <Row>
        <Col css={css`text-align:center;`}>
          <Link to="/sign-up-for-mentorship-coaching">
            <ButtonFill1 variant="outline-light">
                Sign up for mentorship
            </ButtonFill1>
          </Link>
          <OutboundLink href="https://bit.ly/womenworksmentorsignupnew">
            <ButtonFill2 variant="outline-light">
                Become a LadyBoss mentor
            </ButtonFill2>
          </OutboundLink>
        </Col>
      </Row>

        <CardsContainer>
            <Row>
            {WWTeam.map(team => 
              <ProfileCardColumn  xs="12" md="6" lg="4" xl="3">
                <ProfileCard>
                    <Card.Img alt={"WomenWorks Team - " + team.name} variant="top" src={"/ww-team/" + team.picture} />
                    <Card.Body>
                        <CardTitle>{team.name}</CardTitle>
                        <CardText>
                            {team.title}
                        </CardText>
                        {team.linkedinLink && <OutboundLink target="_blank" rel="noreferrer" href={team.linkedinLink}>
                          <SocialMediaIcon icon={faLinkedin} css={css`margin-right:20px;`}/>
                        </OutboundLink>}
                        {team.instagramLink && <OutboundLink target="_blank" rel="noreferrer" href={team.instagramLink}>
                          <SocialMediaIcon icon={faInstagramSquare}/>
                        </OutboundLink>}
                    </Card.Body>
                </ProfileCard>
              </ProfileCardColumn>
              )}
           </Row>
        </CardsContainer>
    </FirstSectionContainer>
    </div>
  )
}